import type { TableData, TableRowData } from '../types/data'
import { generateSafeId } from './data'

export function rowFactory(data?: Record<string, TableData>): TableRowData {
  const id = generateSafeId()
  const row: TableRowData = {
    ...data,
    id,
    orientation: 'row',
    field: id,
    metadata: {},
    elementalTypeId: 0,
  }
  return row
}
